import { render, staticRenderFns } from "./FleetArchivedDailyTasks.vue?vue&type=template&id=4d25b881&scoped=true&"
import script from "./FleetArchivedDailyTasks.vue?vue&type=script&lang=js&"
export * from "./FleetArchivedDailyTasks.vue?vue&type=script&lang=js&"
import style0 from "./FleetArchivedDailyTasks.vue?vue&type=style&index=0&id=4d25b881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25b881",
  null
  
)

export default component.exports